import angular from 'angular';

import * as filters from './filters';

const module = angular.module('mmsApp.filters', []);
Object.keys(filters).forEach(name => {
  let filterFn = filters[name];
  module.filter(name, () => filterFn);
});

export const FiltersModule = module.name;




// WEBPACK FOOTER //
// ./src/app/filters/app.filters.module.js